"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tags = exports.renderTag = exports.htmlTags = exports.getProcessedDomain = exports.br = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getProcessedDomain = domain => {
  if (typeof domain !== 'string' && !(domain instanceof String)) {
    return domain;
  }
  return domain.replace(/\./g, '_');
};
exports.getProcessedDomain = getProcessedDomain;
const br = exports.br = /*#__PURE__*/_react.default.createElement("br", null);
const tags = exports.tags = ['h1', 'h2', 'h3', 'h4', 'h5', 'strong', 'p', 'ul', 'li'];
const renderTag = tag => function () {
  for (var _len = arguments.length, chunks = new Array(_len), _key = 0; _key < _len; _key++) {
    chunks[_key] = arguments[_key];
  }
  return /*#__PURE__*/(0, _react.createElement)(tag, {}, chunks);
};
exports.renderTag = renderTag;
const htmlTags = exports.htmlTags = tags.reduce((result, tag) => ({
  ...result,
  [tag]: renderTag(tag)
}), {});